<template>
    <!-- TELEGRAM -->
    <div id="linkTelegram" class="modal inmodal fade modal-v5">
        <div class="modal-dialog modal-sm">
            <div class="ba-card ba-w-50 ba-mg-t-4">
              <div class="ba-top ba-mg-t-2 ba-pd-x-2 ba-flex ba-jc-sb">
                  <div class="ba-title">
                    <span class="ba-color-blue19 ba-montserrat-600" style="font-size: 22px;" v-html="view.translations.telegram.link_generator"></span>
                  </div>
                  <div class="ba-box-items ba-flex ba-jc-fe">
                    <button type="button" class="ba-btn ba-btn-close ba-sm ba-rounded" data-dismiss="modal" aria-hidden="true">
                      <builderall-icon code="64f7" />
                    </button>
                  </div>
              </div>
              <builderall-loader :loading="loading">
                <div class="ba-content ba-pd-x-2 ba-mg-b-2">
                  <div class="ba-pd-t-1 ba-mg-r-1">
                    <span class="ba-montserrat-500" style="font-size: 14px;" v-html="view.translations.telegram.info_telegram_modal"></span>
                  </div>
                  <div class="ba-w-100">
                    <div class="ba-box-input ba-w-100 ba-mg-t-2">
                      <div class="ba-info">
                          <div class="ba-info-left">
                              <label class="ba-label" for="input_id" v-html="view.translations.telegram.link_generator_username"></label>
                          </div>
                      </div>
                      <input
                          type="text"
                          :placeholder="view.translations.telegram.link_generator_username_placeholder"
                          id="tlg__username"
                          ref="tlg__username"
                          v-model="userText"
                          class="ba-input"
                      />
                    </div>
                    <div class="ba-w-100">
                        <div class="ba-flex ba-jc-fe ba-mg-y-1">
                          <button class="ba-btn ba-lg ba-blue" id="tlg__get_link" ref="tlg__get_link" :disabled="!userText ? true : false" @click="getLinkEventListenner()">
                              <span class="ba-text-capitalize ba-montserrat-400 ba-pd-x-1" v-html="view.translations.telegram.link_generator_get_link"></span>
                          </button>
                        </div>
                        <div v-if="showInputCopy" class="box-input-copy">
                            <div class="ba-box-input">
                                <fs6-input-copy class="ba-color-blue19" :view="[view.translations.telegram.your_link_here,linkGenerated,view.translations.telegram.copied]"></fs6-input-copy>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
              </builderall-loader>
                <!-- <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h4 class="modal-title" v-html="view.translations.telegram.link_generator"></h4>
                    <fs5-collapse-info :view="[view.translations.telegram.link_generator_telegram,view.translations.telegram.info_telegram_modal]"></fs5-collapse-info>
                </div> -->
                <!-- <div class="modal-body">
                    <div class="form-group">
                        <label class="is-required" v-html="view.translations.telegram.link_generator_username"></label>
                        <input type="text" :class="['form-control', !userText ? '' : 'success-input']" :placeholder="view.translations.telegram.link_generator_username_placeholder" id="tlg__username" ref="tlg__username" v-model="userText">
                    </div>
                    <div class="box-btn-link">
                        <button class="btn btn-block is-primary btn-generator" id="tlg__get_link" ref="tlg__get_link" :disabled="!userText ? true : false" @click="getLinkEventListenner()">
                            <b v-if="!showIconAnimation" v-html="view.translations.telegram.link_generator_get_link"></b>
                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                            </svg>
                        </button>
                        <div v-if="showInputCopy" class="box-input-copy">
                            <br>
                            <fs5-input-copy :view="[view.translations.telegram.your_link_here,linkGenerated,view.translations.telegram.copied]"></fs5-input-copy>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [],
        name: 'modal-telegram-v5',
        data: function (){
            return {
                usernameElement: this.$refs.tlg__username,
                getLinkElement: this.$refs.tlg__get_link,
                // generatedLinkElement: this.$refs.tlg__generated_link,
                copyLinkElement: this.$refs.tlg__copy_link,
                generatedResultElement: this.$refs.tlg__generated_result,

                userText: '',
                linkGenerated: '',
                showInputCopy: false,
                showIconAnimation: false,

                //data
                lang: window.lang || 'us',
                loading: true,
                view: { // prevent undefined bugs
                    data: {
                        constList: {
                            affiliate_type_pro: '',
                            application_env: '',
                            ba_gateway_front: '',
                            host_short_url: ''
                        },
                        'dados_usuario_office': {
                            affiliate_type: '',
                            email: '',
                            id: ''
                        },
                        link_user: '',
                        access_short_url: '/us/office/url-shortener',
                    },
                    translations: {
                        telegram:{
                            copied: '',
                            link_generator_get_link: '',
                            link_generator_here_is_your_link: '',
                            link_generator_modal_title_telegram: '',
                            link_generator_username: '',
                            link_generator_username_placeholder: ''
                        }
                    }
                },
            }
        },
        methods: {
            forceInitRefs() {
                this.usernameElement = this.$refs.tlg__username
                this.getLinkElement = this.$refs.tlg__get_link
                // this.generatedLinkElement = this.$refs.tlg__generated_link
                this.copyLinkElement = this.$refs.tlg__copy_link
                this.generatedResultElement = this.$refs.tlg__generated_result
            },
            getLinkEventListenner() {
                if(!this.userText)
                {
                    alertMsg("error", this.view.translations.telegram.complete_correctly_field);
                }
                else
                {
                    //button animation
                    if(!this.showIconAnimation)
                    {
                        this.showIconAnimation = true;
                        setTimeout(() => {
                            this.showIconAnimation = false;
                            document.activeElement.blur();
                        }, 2000);
                    }

                    this.showInputCopy = true;
                    //create url
                    let username = String(this.usernameElement.value).replace(/^@/g, '').trim();
                    let generatedLink = `https://t.me/${username}`;
                    this.linkGenerated = generatedLink;
                    // this.generatedLinkElement.value = generatedLink;
                    this.generatedResultElement.removeAttribute('hidden');
                }
            },
            init: async function(){
                await this.requestDataLinkGenerators()
                this.forceInitRefs()

                let vm = this
                $('#tlg__copy_link').popover({
                    title: '',
                    container: '#tlg__generated_result',
                    content: vm.view.translations.telegram.copied,
                    placement: 'left',
                    trigger: "manual"
                });

                // this.generatedResultElement.setAttribute('hidden', true);
            },
            requestDataLinkGenerators: async function (){
                this.loading = true
                try{
                    let res = await axios.get(`/${this.lang}/office/franchise-system/link-generators/data`)
                    res = res.data.data
                    this.$set(this.$data, 'view', res)
                } catch(e) {
                    console.log('error = ', e.getMessage())
                } finally {
                    this.loading = false
                }
            }
        },
        mounted() {
            $('#linkTelegram').on('show.bs.modal', this.init)
        }
    }
</script>

<style scoped lang="scss">
    .modal-content{
        width: 90%;
        .modal-title{
            text-align: left !important;
            padding-left: 1em;
            color: #A5B9D5 !important;
            font-size: 1.8em !important;
            font-family: Lato;
            text-transform: uppercase;
        }
        .modal-body{
            padding-top: 0 !important;
            .form-group{
                .success-input{
                    border: 1px solid #02EAA0 !important;
                }
                input::placeholder{
                    font-weight: 200;
                }
            }
            .box-btn-link{
                background-color: #EDF1F7;
                border-radius: 5px;
                padding: 1em;
                display: flex;
                flex-direction: column;
                flex-wrap: wrap;
                align-items: center;
                justify-content: space-between;
                label{
                    font-size: .8em !important;
                }
                .box-input-copy{
                    width: 100%;
                }
            }
            .btn-generator{
                z-index: 1;
                position: relative;
                border: none;
                width: 100%;
                padding: 0.43em !important;
                svg{
                    color: #02EAA0;
                    animation-name: svgSuccess;
                    animation-duration: 1s;
                }
            }
            .btn-generator::before{
                position: absolute;
                border-radius: 8px;
                z-index: -1;
                content: '';
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                transform: scaleX(0);
                transition: transform .8s ease-in-out;
                transform-origin: left;
                background-color: #0763cc;
            }
            .btn-generator:focus::before{
                transform: scaleX(1);
            }
        }
    }
    @media only screen and (max-width: 780px) {
        .modal-title{
            font-size: 1.3em !important;
        }
    }
    @keyframes svgSuccess {
        from {transform: rotate(0deg);}
        to {transform: rotate(360deg);}
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/modals/Telegram.vue